
<nav>
    <a href="https://github.com/Rolands-Laucis/Pauca">github</a>
    <a href="https://github.com/Rolands-Laucis/Pauca/blob/master/specification.md">specification</a>
    <a href="https://github.com/Rolands-Laucis/Pauca/tree/master/examples">examples</a>
</nav>

<style lang="scss">
    nav{
        width: 100%;
        height: 48px;

        display: flex;
        justify-content: center;
        align-items: center;
        gap: 24px;
    }

    a{
        @include link;
    }
</style>